/**
 * Serviço de despesas
 * Funções para gerenciar despesas
 */

import api from './api';

/**
 * Lista todas as despesas
 */
export const listarDespesas = async () => {
  const response = await api.get('/despesas');
  return response;
};

/**
 * Cria uma nova despesa
 */
export const criarDespesa = async (despesa) => {
  const response = await api.post('/despesas', despesa);
  return response;
};

/**
 * Atualiza uma despesa
 */
export const atualizarDespesa = async (id, despesa) => {
  const response = await api.put(`/despesas/${id}`, despesa);
  return response;
};

/**
 * Remove uma despesa
 */
export const deletarDespesa = async (id) => {
  const response = await api.delete(`/despesas/${id}`);
  return response;
};

/**
 * Faz upload de comprovante para uma despesa
 */
export const uploadComprovante = async (id, arquivo) => {
  const formData = new FormData();
  formData.append('comprovante', arquivo);
  const response = await api.post(`/despesas/${id}/comprovante`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response;
};

/**
 * Remove comprovante de uma despesa
 */
export const removerComprovante = async (id) => {
  const response = await api.delete(`/despesas/${id}/comprovante`);
  return response;
};
